import React, { useState, useEffect } from 'react';
import { Alert, Snackbar } from '@mui/material';
import { CloudOff as CloudOffIcon, CloudDone as CloudDoneIcon } from '@mui/icons-material';

export default function OfflineIndicator() {
  const [showOfflineMessage, setShowOfflineMessage] = useState(false);
  const [showOnlineMessage, setShowOnlineMessage] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setShowOnlineMessage(true);
      setTimeout(() => setShowOnlineMessage(false), 3000);
    };

    const handleOffline = () => {
      setShowOfflineMessage(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Check initial state
    if (!navigator.onLine) {
      setShowOfflineMessage(true);
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <>
      {/* Offline Snackbar */}
      <Snackbar
        open={showOfflineMessage}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={null} // Don't auto-hide offline message
        onClose={() => setShowOfflineMessage(false)}
      >
        <Alert
          severity="warning"
          icon={<CloudOffIcon />}
          onClose={() => setShowOfflineMessage(false)}
          sx={{ width: '100%' }}
        >
          You&apos;re offline. Some features may be limited. Data will sync when connection is restored.
        </Alert>
      </Snackbar>

      {/* Online Snackbar */}
      <Snackbar
        open={showOnlineMessage}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={3000}
        onClose={() => setShowOnlineMessage(false)}
      >
        <Alert
          severity="success"
          icon={<CloudDoneIcon />}
          onClose={() => setShowOnlineMessage(false)}
          sx={{ width: '100%' }}
        >
          Connection restored. Syncing data...
        </Alert>
      </Snackbar>
    </>
  );
}

